import { callApi } from "@/api/api-core";

export const claimBasket = function(
    orderId,
    customerName,
    email,
    ownerHandlesFailure
) {
    const requestData = {
        orderId,
        customerName,
        email
    };

    return callApi(
        "POST",
        "v3/basket/claim/anonymous",
        requestData,
        ownerHandlesFailure
    );
};
